import React, { useEffect } from 'react';

interface IPlansCardFooter {
  type: string;
  activePlan: any;
  createCheckoutSession: any;
  createCustomerPortalSession: any;
  cusId: string;
  setCancelMode: any;
  setRenewMode: any;
  cusObj: any;
  cur_user: any;
  handleNewPlanChange: any;
  planState: any;
  currentPlan: any;
  setCurrentPlan: any;
  team: any;
  newPlan: any;
  subInfo: any;
}

const PlansCardFooter: React.FC<IPlansCardFooter> = ({ subInfo, team, setCurrentPlan, currentPlan, planState, handleNewPlanChange, cusObj, type, activePlan, cusId, setCancelMode, setRenewMode }) => {
  useEffect(() => {
    setCurrentPlan({ isLoading: false, data: planState.data });
  }, [ team ]);

  return (
    <div className='plans-card-footer' onClick={() => handleNewPlanChange(type)}>
      {type === 'Standard' && (
        <>
          {
            type !== activePlan.data &&
            activePlan.data !== 'none' &&
            subInfo.status !== 'trialing' &&
            !subInfo.cancel_at_period_end &&
            (
              <>
                <div className='plans-card-select-btn'>
                  <div className='plans-card-btn-spacing'>
                    <div className='plans-card-btn-text'>
                      Select
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {type === activePlan.data && !subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' onClick={() => setCancelMode(true)}>
              <div className='plans-card-btn-spacing'>
                <div className='plans-card-btn-text'>
                  Cancel Plan
                </div>
              </div>
            </div>
          )}
          {type === activePlan.data && subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' style={{ cursor: 'default' }}>
              <div className='plans-card-btn-spacing'>
                {planState.data.selectedPrice.interval === currentPlan.data.selectedPrice.interval && (
                  <div className='plans-card-btn-text' style={{ color: '#BDBEC1' }}>
                    Canceled
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      {type === 'Pro' && (
        <>
          {
            type !== activePlan.data &&
            activePlan.data !== 'none' &&
            subInfo?.status !== 'trialing' &&
            !subInfo?.cancel_at_period_end &&
            (
              <>
                <div className='plans-card-select-btn'>
                  <div className='plans-card-btn-spacing'>
                    <div className='plans-card-btn-text'>
                      Select
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {type === activePlan.data && !subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' onClick={() => setCancelMode(true)}>
              <div className='plans-card-btn-spacing'>
                <div className='plans-card-btn-text'>
                  Cancel Plan
                </div>
              </div>
            </div>
          )}
          {type === activePlan.data && subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' style={{ cursor: 'default' }}>
              <div className='plans-card-btn-spacing'>
                {planState.data.selectedPrice.interval === currentPlan.data.selectedPrice.interval && (
                  <div className='plans-card-btn-text' style={{ color: '#BDBEC1' }}>
                    Canceled
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      {type === 'Enterprise' && (
        <>
          {
            type !== activePlan.data &&
            activePlan.data !== 'none' &&
            subInfo?.status !== 'trialing' &&
            !subInfo?.cancel_at_period_end &&
            (
              <>
                <div className='plans-card-select-btn'>
                  <div className='plans-card-btn-spacing'>
                    <div className='plans-card-btn-text'>
                      Select
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {type === activePlan.data && !subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' onClick={() => setCancelMode(true)}>
              <div className='plans-card-btn-spacing'>
                <div className='plans-card-btn-text'>
                  Cancel Plan
                </div>
              </div>
            </div>
          )}
          {type === activePlan.data && subInfo?.cancel_at_period_end && subInfo?.status !== 'trialing' && (
            <div className='plans-card-cancel-btn' style={{ cursor: 'default' }}>
              <div className='plans-card-btn-spacing'>
                {planState.data.selectedPrice.interval === currentPlan.data.selectedPrice.interval && (
                  <div className='plans-card-btn-text' style={{ color: '#BDBEC1' }}>
                    Canceled
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PlansCardFooter;
